import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button } from "@mui/material";
import { ModalDialog } from "Components/Shared/Dialogs/ModalDialog";
import { BeneficialOwnerForm } from "Components/Shared/Merchant/BeneficialOwners/BeneficialOwnerForm";
import { AddBusinessRolePartyForm } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/Add/AddBusinessRolePartyForm";
import { AddRelationTypeSelector } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/Add/AddRelationTypeSelector";
import { RelationType } from "Infrastructure/Api/Api";
import { type ReactNode, useState } from "react";
import { Resources, useResource } from "Translations/Resources";

const ADD_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties.Add;

type Props = {
  owningPartyID: string;
};

export const AddRelatedParty = ({ owningPartyID }: Props) => {
  const [relationType, setRelationType] = useState<RelationType | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    setRelationType(null);
  };

  const layoutProps = {
    isOpen,
    relationType,
    onOpen: () => setIsOpen(true),
    onClose: handleClose,
    onRelationTypeChange: setRelationType,
  };

  if (!relationType) {
    return <Layout {...layoutProps} />;
  }

  if (relationType === RelationType.BeneficialOwner) {
    return (
      <Layout {...layoutProps}>
        <BeneficialOwnerForm
          owningPartyID={owningPartyID}
          beneficialOwner={{}}
          onAfterSubmit={(isSuccess) => {
            if (isSuccess) {
              handleClose();
            }
          }}
        />
      </Layout>
    );
  }

  return (
    <Layout {...layoutProps}>
      <AddBusinessRolePartyForm
        owningPartyID={owningPartyID}
        relationType={relationType}
        onSuccess={handleClose}
      />
    </Layout>
  );
};

type LayoutProps = {
  isOpen: boolean;
  relationType: RelationType | null;
  onOpen: () => void;
  onClose: () => void;
  onRelationTypeChange: (relationType: RelationType | null) => void;
  children?: ReactNode;
};

const Layout = ({
  isOpen,
  relationType,
  onOpen,
  onClose,
  onRelationTypeChange,
  children,
}: LayoutProps) => {
  const { t } = useResource();

  return (
    <>
      <Button
        variant="text"
        startIcon={<AddCircleOutlineIcon />}
        onClick={onOpen}
      >
        {t(ADD_RESOURCES.Button)}
      </Button>
      <ModalDialog
        isOpen={isOpen}
        onClose={onClose}
        title={t(ADD_RESOURCES.Title)}
      >
        <AddRelationTypeSelector
          value={relationType}
          onChange={onRelationTypeChange}
        />
        {children}
      </ModalDialog>
    </>
  );
};
